import * as React from 'react'
import { cn } from '../../lib/cn'

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn(
      'h-12 w-full rounded-md border border-line bg-white px-3.5 text-[15px] text-ink outline-none placeholder:text-muted focus:border-clay focus:ring-2 focus:ring-clay/15',
      className,
    )} {...props} />
  ),
)
Input.displayName = 'Input'
